<template>
  <div class="contact-wrapper">
    <div
      v-prlx.background="{ speed: 0.05 }"
      class="contact-header-background"
    ></div>
    <div class="contact-content-container">
      <div class="contact-form-holder">
        <!--  <form class="contact-inputs">
          <input class="input-name" required placeholder="Name" type="text" />
          <input class="input-email" required placeholder="Email" type="text" />
          <input
            class="input-span subject"
            required
            placeholder="Subject"
            type="text"
          />

          <textarea
            class="input-span message"
            required
            placeholder="Message"
            type="text"
          />
          <a-button class="contact-form-button">Send</a-button>
        </form> -->
      </div>
      <div class="contact-text-holder">
        <h1>Kontakt oss</h1>
        <p>
          Lurer du på noe? Gi oss ros eller tilbakemelding? Ikke nøl med å
          kontakte oss!
        </p>

        <a-icon type="facebook" :style="{ fontSize: '3em' }"></a-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "Contact"
};
</script>

<style lang="scss" scoped>
$desktop: 1200px;
$laptop: 1024px;
$tablet: 768px;
$mobile: 480px;

.contact-text-holder {
  & h1 {
    margin: 0;
    line-height: 20px;
    font-family: bebas;
  }
  & p {
    margin-top: 2.5em;
    font-family: Roboto;
    color: #8b8b8b;
  }

  @media (max-width: $mobile) {
    margin: 2em;
    text-align: center;
  }
}

.contact-header-background {
  background-image: url("~@/assets/images/contact-us-background-img.png");
  height: 490px;
  width: 100%;
  object-fit: cover;
  background-position: center;
  margin-top: 10px;
  display: grid;
  place-items: center;

  @media (max-width: $mobile) {
    height: 300px;
  }
}

.contact-content-container {
  margin: 2rem 3rem 2rem 3rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 1rem;

  @media (max-width: $mobile) {
    margin: 0;
    display: flex;
    flex-direction: column-reverse;
  }
}

.contact-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;

  .subject {
    border-top: none;
  }
}
.contact-inputs input {
  height: 4.5em;
  padding: 1em 0em 1em 1em;
  border: 1px solid #111;
  border-radius: 0px;
  background-color: transparent;

  outline: 0;
}

.contact-inputs .input-name {
  border-right: none;
}
.input-span {
  grid-column: 1 / span 2;
}

.contact-inputs .message {
  height: 15em;
  padding: 1em 1em 1em 1em;
  resize: none;
  outline: 0;
  border: 1px solid #111;
  border-bottom: none;
  border-top: none;
}
.contact-form-button {
  grid-column: 1 / span 2;
}

/* Overides antVue css*/
.ant-btn {
  border-color: #000000 !important;
  border: 1px solid #000000 !important;
  border-radius: 0px !important;
  height: 3.5em;
  font-family: Bebas, sans-serif;
  font-size: 1.5em;
}
.ant-btn:hover,
.ant-btn:focus {
  background: #000000 !important;
  color: #ffffff !important;
}

.ant-layout {
  height: 100vh;
}
</style>
